import BrandSearchSelect from '../../../components/selects/BrandSearchSelect'
import ProductSearchSelect from '../../../components/selects/ProductSearchSelect'
import CategorySearchSelect from '../../../components/selects/CategorySearchSelect'
import CampaignSearchSelect from '../../../components/selects/CampaignSearchSelect'
import CampaignProductSelect from '../../../components/selects/CampaignProductSelect'
import PagesSelect from 'components/selects/PagesSelect'
import PredictionSelect from 'components/selects/PredictionSelect'

const NotificationSelects = ({
  notification,
  generateSeoUrl,
  setNotification,
  setSelectedOption,
  selectedOption,
  displayBrandSearch,
  displayProductSearch,
  displayCategorySearch,
  displayCampaignSearch,
  displayProductCampaignList,
  displayPagesList,
  displayPredictionCampaigns
}) => {
  return (
    <div>
      {/*Brand search section*/}
      {displayBrandSearch && (
        <BrandSearchSelect
          label="Select Brand"
          onChange={(v) => {
            setSelectedOption(v)
            setNotification({
              ...notification,
              extras: {
                ...notification.extras,
                name: v.name,
                id: `${v.id}`,
              },
            })
            generateSeoUrl(v)
          }}
          value={selectedOption}
          extData={notification?.extras?.id}
        />
      )}

      {/*/!*Product search section*!/*/}
      {displayProductSearch && (
        <ProductSearchSelect
          label="Select Product"
          onChange={(v) => {
            setSelectedOption(v)
            setNotification({
              ...notification,
              extras: {
                ...notification.extras,
                name: v.label,
                id: v.item,
              },
            })
            generateSeoUrl(v)
          }}
          value={selectedOption}
          extData={notification?.extras?.id}
        />
      )}

      {/*/!*Category search section*!/*/}
      {displayCategorySearch && (
        <CategorySearchSelect
          label="Select Category"
          onChange={(v) => {
            setSelectedOption(v)
            setNotification({
              ...notification,
              extras: {
                ...notification.extras,
                name: v.name,
                id: `${v.id}`,
              },
            })
            generateSeoUrl(v)
          }}
          value={selectedOption}
          extData={notification?.extras?.id}
        />
      )}

      {/*/!*Campaigns search section*!/*/}
      {displayCampaignSearch && (
        <CampaignSearchSelect
          label="Select Campaign"
          onChange={(v) => {
            setSelectedOption(v)
            setNotification({
              ...notification,
              extras: {
                ...notification.extras,
                name: v.name,
                id: `${v.id}`,
              },
            })
            generateSeoUrl(v)
          }}
          value={selectedOption}
          extData={notification?.extras?.id}
        />
      )}

      {displayProductCampaignList && (
        <CampaignProductSelect
          label="Search Product Campaign"
          value={selectedOption}
          onChange={(campaign) => {
            setSelectedOption(campaign)
            setNotification({
              ...notification,
              extras: {
                ...notification.extras,
                name: campaign.name,
                id: `${campaign.id}`,
              },
            })
            generateSeoUrl(campaign)
          }}
          type={notification?.extras?.sub_group}
          extData={notification?.extras?.id}
        />
      )}
      {displayPagesList && (
        <PagesSelect
          label="Select Pages"
          onChange={(v) => {
            setSelectedOption(v)
            setNotification({
              ...notification,
              extras: {
                ...notification.extras,
                name: v.title,
                id: `${v.id}`,
              },
            })
            generateSeoUrl(v)
          }}
          value={selectedOption}
          extData={notification?.extras?.id}
        />
      )}

    </div>
  )
}

export default NotificationSelects
